import React from 'react';
import { Link } from 'react-scroll';

const Hero = () => {
    return (
        <section id="home" className="bg-gradient-to-r from-red-900 to-black text-white min-h-[80vh] flex items-center px-6 md:px-16 py-20">
            <div className="w-full flex flex-col md:flex-row items-start gap-12" data-aos="fade-up" data-aos-duration="1000">

                <div className="text-center mb-16 max-w-3xl mx-auto">
                    <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-4">
                        Elevate Your <span className="text-red-500">Cybersecurity Skills</span>
                    </h1>
                    <p className="text-gray-300">
                        Join our immersive training programs, from beginner to advanced, designed by industry professionals
                        to build defenders for the digital frontier.
                    </p>
                    <div className="flex justify-center mt-6 gap-4">
                        <Link
                            to="contact"
                            smooth={true}
                            offset={-20}
                            duration={500}
                            className="border border-red-600 hover:bg-red-700 hover:text-white text-red-400 font-semibold px-5 py-2 rounded inline-block cursor-pointer"
                        >
                            Request Training
                        </Link>
                        <Link
                            to="services"
                            smooth={true}
                            offset={-20}
                            duration={500}
                            className="bg-red-600 hover:bg-red-700 text-white font-semibold px-5 py-2 rounded inline-block cursor-pointer"
                        >
                            Explore Programs
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
